import React, { createContext } from 'react'

export const MainNavigationContext = createContext({
  selectedParentMenu: null,
  mobileNavOpen: false,
  setSelectedParentMenu: (state: string | null) => {},
  setMobileNavOpen: (state: boolean) => {}
})

export default MainNavigationContext
